import { IpgTypeEnum } from "@payping/api";
import { useAppTranslation } from "@/utils/useAppTranslation";

export enum PaymentGateway {
  Sadad = 1,
  Mellat,
  Pep,
  Saman,
  Mabna,
}

export const useIpgTypeMap = (): ((type?: IpgTypeEnum) => string) => {
  const { t } = useAppTranslation();

  return (type?: IpgTypeEnum) => {
    switch (type) {
      case IpgTypeEnum.AP_Pos:
        return t("common.gateway.AP_Pos");
      case IpgTypeEnum.Affilite:
        return t("common.gateway.Affilite");
      case IpgTypeEnum.AnsarCC:
        return t("common.gateway.AnsarCC");
      case IpgTypeEnum.Ap:
        return t("common.gateway.Ap");
      case IpgTypeEnum.AyandeCC:
        return t("common.gateway.AyandeCC");
      case IpgTypeEnum.Cash:
        return t("common.gateway.Cash");
      case IpgTypeEnum.DayCC:
        return t("common.gateway.DayCC");
      case IpgTypeEnum.DirectPayment:
        return t("common.gateway.DirectPayment");
      case IpgTypeEnum.Emtiyaz:
        return t("common.gateway.Emtiyaz");
      case IpgTypeEnum.Fanava:
        return t("common.gateway.Fanava");
      case IpgTypeEnum.Fanava_Pos:
        return t("common.gateway.Fanava_Pos");
      case IpgTypeEnum.Ghesta:
        return t("common.gateway.Ghesta");
      case IpgTypeEnum.HamrahCard:
        return t("common.gateway.HamrahCard");
      case IpgTypeEnum.IranKish:
        return t("common.gateway.IranKish");
      case IpgTypeEnum.IranKishMPos:
        return t("common.gateway.IranKishMPos");
      case IpgTypeEnum.IranKish_Pos:
        return t("common.gateway.IranKish_Pos");
      case IpgTypeEnum.Jibimo:
        return t("common.gateway.Jibimo");
      case IpgTypeEnum.Jibit:
        return t("common.gateway.Jibit");
      case IpgTypeEnum.Kipaad:
        return t("common.gateway.Kipaad");
      case IpgTypeEnum.Kipo:
        return t("common.gateway.Kipo");
      case IpgTypeEnum.MSep:
        return t("common.gateway.MSep");
      case IpgTypeEnum.Mabna:
        return t("common.gateway.Mabna");
      case IpgTypeEnum.Mabna_Pos:
        return t("common.gateway.Mabna_Pos");
      case IpgTypeEnum.Mellat:
        return t("common.gateway.Mellat");
      case IpgTypeEnum.MellatMultiIBan:
        return t("common.gateway.MellatMultiIBan");
      case IpgTypeEnum.Mellat_Pos:
        return t("common.gateway.Mellat_Pos");
      case IpgTypeEnum.NoIpg:
        return t("common.gateway.NoIpg");
      case IpgTypeEnum.Nobitex:
        return t("common.gateway.Nobitex");
      case IpgTypeEnum.PNA_Pos:
        return t("common.gateway.PNA_Pos");
      case IpgTypeEnum.Paygear:
        return t("common.gateway.Paygear");
      case IpgTypeEnum.Pec:
        return t("common.gateway.Pec");
      case IpgTypeEnum.PecMultiIBan:
        return t("common.gateway.PecMultiIBan");
      case IpgTypeEnum.Pec_MPL:
        return t("common.gateway.Pec_MPL");
      case IpgTypeEnum.Pec_Pos:
        return t("common.gateway.Pec_Pos");
      case IpgTypeEnum.Pep:
        return t("common.gateway.Pep");
      case IpgTypeEnum.Pep_Pos:
        return t("common.gateway.Pep_Pos");
      case IpgTypeEnum.Phonepay:
        return t("common.gateway.Phonepay");
      case IpgTypeEnum.Pna:
        return t("common.gateway.Pna");
      case IpgTypeEnum.PostCC:
        return t("common.gateway.PostCC");
      case IpgTypeEnum.Sadad:
        return t("common.gateway.Sadad");
      case IpgTypeEnum.Sadad_IPos:
        return t("common.gateway.Sadad_IPos");
      case IpgTypeEnum.Sadad_PcPos:
        return t("common.gateway.Sadad_PcPos");
      case IpgTypeEnum.Sadad_Pos:
        return t("common.gateway.Sadad_Pos");
      case IpgTypeEnum.Sep:
        return t("common.gateway.Sep");
      case IpgTypeEnum.SepOnlinePG:
        return t("common.gateway.SepOnlinePG");
      case IpgTypeEnum.Sep_Pos:
        return t("common.gateway.Sep_Pos");
      case IpgTypeEnum.ShahrCC:
        return t("common.gateway.ShahrCC");
      case IpgTypeEnum.Toman:
        return t("common.gateway.Toman");
      case IpgTypeEnum.Tosan_D_180:
        return t("common.gateway.Tosan_D_180");
      default:
        return "None";
    }
  };
};
